import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../../../utils/PropTypesDefinitions'
import HeaderFont from '../../HeaderFont'

export type Props = {
    /**
     * Label for competitor.
     * e.g. Team/ Name
     */
    competitorLabel: string

    /**
     * Is there a more button
     */
    hasMore?: boolean
} & TestID

const HeaderTemplate: FunctionComponent<Props> = ({
    competitorLabel,
    hasMore,
    testID,
    children,
}): ReactElement => {
    return (
        <Grid minHeight={33} height={33} backgroundColor="pearl" testID={testID}>
            <Grid horizontal borderBottom="1px" borderColor="tahitian-4">
                <Grid
                    width={16}
                    marginLeft={[12, 12, 20]}
                    marginRight={[12, 12, 38]}
                    noExpand
                    center
                >
                    <HeaderFont align="center">Pl.</HeaderFont>
                </Grid>
                <Grid
                    centerVertical
                    minWidth={0}
                    horizontal
                    marginLeft={[12, 12, 0]}
                    marginRight={[1, 1, 12, 16]}
                    expand
                >
                    <Grid minWidth={0} noExpand>
                        <HeaderFont align="left">{competitorLabel}</HeaderFont>
                    </Grid>
                </Grid>
                {children}
                {hasMore ? (
                    <Grid
                        width={[28, 28, 26]}
                        noExpand
                        center
                        marginLeft={[1, 1, 12]}
                        marginRight={5}
                    >
                        <HeaderFont align="center">Mehr</HeaderFont>
                    </Grid>
                ) : (
                    <Grid width={12} noExpand />
                )}
            </Grid>
        </Grid>
    )
}

export default HeaderTemplate
